<template>
    <picture class="image-wraper" ref="imageWrapper">
        <template v-if="isIntersecting">
            <source :srcset="computedSrc.avif" type="image/avif">
            <source :srcset="computedSrc.webp" type="image/webp">
            <source :srcset="computedSrc.png" type="image/png">
            <img loading="lazy" :style="computedSize" alt="">
        </template>
    </picture>
</template>
<script setup>
import config from '@img/config.json'
import { onMounted } from 'vue';
import { useGlobalState } from '../plugins/vue/store';
const { supportLazyImage } = useGlobalState()
console.log(config,'11')
const props = defineProps({
    src: {
        type: String,
        default: 'txm_logo'
    },
    size: {
        type: Object,
    },
})
const computedSrc = ref({ avif: '', webp: '', png: '' });
async function loadImageUrls() {
    let getImageUrls;
    if (import.meta.env.MODE === 'development') {
        getImageUrls = await import('./imageUrl.dev.js').then(module => module.getImageUrls);
    } else {
        getImageUrls = await import('./imageUrl.prod.js').then(module => module.getImageUrls);
    }

    computedSrc.value = getImageUrls(props.src);
}


const computedSize = computed(() => {
    if (props.size) {
        return {
            width: px2Vw(props.size.width) + 'vw',
            height: px2Vw(props.size.height) + 'vw'
        }
    } else {
        var size=config[props.src]
        return {
            width:px2Vw(size.width)+'vw',
            height:px2Vw(size.height)+'vw'
        }
    }
})

function px2Vw(px) {
    return parseFloat((px / 750) * 100)
}
const isIntersecting = ref(false);
const observer = ref(null);
const imageWrapper = ref(null);
function handleIntersection(entries) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            isIntersecting.value = true;
            observer.value.disconnect(); // 图片加载后，停止观察
        }
    });
}

onMounted(async () => {
    if (supportLazyImage.value == 'true') {
        isIntersecting.value = true
    } else {
        observer.value = new IntersectionObserver(handleIntersection, {
            rootMargin: '0px',
            threshold: 0.1,
        });
        if (imageWrapper.value) {
            observer.value.observe(imageWrapper.value);
        }
    }

    loadImageUrls();
})
onBeforeUnmount(() => {
    if (observer.value) {
        observer.value.disconnect();
    }
});
</script>
<style>
.image-wraper {
    display: flex;
    align-items: center;
}

.image-circle {
    border-radius: 50%;
}
</style>
